/**
 * Berndorf — seitenweites Popup (snippets/berndorf-popup.liquid).
 *
 * Zeitraum, Verzögerung und „schon geschlossen“ werden hier geprüft, nicht in
 * Liquid: Shopify liefert Seiten aus dem Cache, ein serverseitiges Datum wäre
 * bis zum nächsten Neuaufbau eingefroren.
 *
 * Liegt die Aktion außerhalb ihres Zeitraums, kommt das Newsletter-Popup
 * (role="fallback") zum Zug. Hat jemand die laufende Aktion geschlossen,
 * erscheint stattdessen nichts, auch nicht der Newsletter.
 *
 * Ein ungültiges Datum hält die Aktion zu, statt sie dauerhaft zu zeigen.
 * Solange Shopifys Cookie-Banner oder ein Drawer offen ist, wartet das Popup.
 */
(function () {
  'use strict';

  var primary = document.querySelector('[data-berndorf-popup][data-role="primary"]');
  if (!primary || typeof primary.showModal !== 'function') return;
  var fallback = document.querySelector('[data-berndorf-popup][data-role="fallback"]');

  var DAY = 24 * 60 * 60 * 1000;
  var SUBSCRIBED_KEY = 'berndorf-newsletter-subscribed';

  function read(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  function storageKey(dialog) {
    return 'berndorf-popup:' + dialog.dataset.key;
  }

  function parseDate(value, endOfDay) {
    if (!value) return null;
    var match = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(value.trim());
    if (!match) return NaN;
    var day = Number(match[1]);
    var month = Number(match[2]) - 1;
    var year = Number(match[3]);
    var date = endOfDay ? new Date(year, month, day, 23, 59, 59) : new Date(year, month, day);
    if (date.getDate() !== day || date.getMonth() !== month) return NaN;
    return date.getTime();
  }

  function inSchedule(dialog) {
    var start = parseDate(dialog.dataset.start, false);
    var end = parseDate(dialog.dataset.end, true);
    if (Number.isNaN(start) || Number.isNaN(end)) {
      console.warn('Berndorf-Popup: Datum nicht erkannt, erwartet TT.MM.JJJJ.');
      return false;
    }
    var now = Date.now();
    if (start !== null && now < start) return false;
    if (end !== null && now > end) return false;
    return true;
  }

  function available(dialog) {
    if (Number(read(storageKey(dialog))) > Date.now()) return false;
    if (dialog.dataset.mode === 'newsletter' && read(SUBSCRIBED_KEY)) return false;
    return true;
  }

  function choose() {
    if (primary.dataset.preview === 'true') return primary;
    if (inSchedule(primary)) return available(primary) ? primary : null;
    return fallback && available(fallback) ? fallback : null;
  }

  var dialog = choose();
  if (!dialog) return;
  var preview = dialog.dataset.preview === 'true';
  var days = Number(dialog.dataset.days) || 30;

  function remember(forDays) {
    var key = storageKey(dialog);
    var until = Date.now() + forDays * DAY;
    if (preview || Number(read(key)) > until) return;
    write(key, String(until));
  }

  function isShown(element) {
    return !!element && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  }

  function pageIsBusy() {
    if (isShown(document.getElementById('shopify-pc__banner'))) return true;
    if (document.querySelector('dialog[open]')) return true;
    return document.body.classList.contains('overflow-hidden');
  }

  function open() {
    if (pageIsBusy()) {
      window.setTimeout(open, 1500);
      return;
    }
    dialog.showModal();
    document.documentElement.classList.add('berndorf-popup-open');
  }

  dialog.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
    img.loading = 'eager';
  });

  dialog.addEventListener('close', function () {
    document.documentElement.classList.remove('berndorf-popup-open');
    remember(days);
  });

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog || event.target.closest('[data-berndorf-popup-close]')) {
      dialog.close();
      return;
    }

    if (event.target.closest('[data-berndorf-popup-follow]')) {
      remember(days);
      return;
    }

    var copy = event.target.closest('[data-berndorf-popup-copy]');
    if (!copy) return;
    var selectCode = function () {
      var code = dialog.querySelector('.berndorf-popup__code-value');
      var range = document.createRange();
      range.selectNodeContents(code);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
    };
    if (!navigator.clipboard) {
      selectCode();
      return;
    }
    navigator.clipboard.writeText(copy.dataset.berndorfPopupCopy).then(function () {
      copy.textContent = copy.dataset.copiedLabel;
    }, selectCode);
  });

  document.addEventListener('berndorf:newsletter-subscribed', function () {
    remember(365);
  });

  window.setTimeout(open, preview ? 300 : (Number(dialog.dataset.delay) || 0) * 1000);
})();
